import React, { useState, useEffect } from "react";
import { X, RefreshCw, MessageSquare, RotateCcw } from "lucide-react";

export default function UpdateBidModal({ isOpen, onClose, poNumber, onConfirm, isReopen = false, currentStatus = "" }) {
  const [newPoNumber, setNewPoNumber] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNewPoNumber(poNumber || "");
      setReason("");
      setError("");
    }
  }, [isOpen, poNumber]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newPoNumber.trim()) {
      setError("Please enter an EST number.");
      return;
    }
    if (!reason.trim()) {
      setError(isReopen ? "Please enter a reason for reopening the estimate." : "Please enter a reason for updating the bid.");
      return;
    }
    setError("");
    onConfirm(newPoNumber.trim(), reason.trim());
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "480px" }}>
        <div className="modal-header">
          <h3 style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {isReopen ? (
              <>
                <RotateCcw size={20} className="text-warning" /> Reopen Estimate - {poNumber}
              </>
            ) : (
              <>
                <RefreshCw size={20} className="text-warning" /> Update Bid - {poNumber}
              </>
            )}
          </h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: "1.5rem" }}>
          {error && (
            <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>
              {error}
            </div>
          )}

          <p style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginBottom: "1.25rem", lineHeight: 1.4 }}>
            {isReopen ? (
              <>
                This will reopen the completed estimate{currentStatus ? ` (${currentStatus})` : ""} and return it to the active workspace as <strong>Update Bid</strong>. You can adjust the EST Number below if needed.
              </>
            ) : (
              <>
                This will change the status of the bid proposal to <strong>Update Bid</strong>. You can update the EST Number below.
              </>
            )}
          </p>

          <div className="form-group" style={{ marginBottom: "1rem" }}>
            <label className="form-label" htmlFor="newPoNumber">EST Number *</label>
            <input
              id="newPoNumber"
              type="text"
              className="form-input"
              value={newPoNumber}
              onChange={(e) => setNewPoNumber(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="updateReason" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
              <MessageSquare size={14} /> {isReopen ? "Reason for Reopening *" : "Reason for Update *"}
            </label>
            <textarea
              id="updateReason"
              className="form-input"
              rows={4}
              style={{ minHeight: "100px", padding: "0.75rem" }}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={isReopen ? "Explain why this estimate is being reopened..." : "Explain why the customer wants to change or update their order..."}
              required
            />
          </div>

          <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "1.5rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-warning" style={{ color: "var(--bg-card)" }}>
              {isReopen ? "Reopen Estimate" : "Update Bid Status"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
